import * as React from 'react';
import {
  createFileRoute,
  notFound,
  useMatchRoute,
} from '@tanstack/react-router';
import { useEffect, useState } from 'react';

import { endpointDocumentsGET } from '~/api/def/endpoints/document/documentsEndpoint';
import { z } from 'zod';
import { canAccess } from '~/utils/rbac';

const documentSearchSchema = z.object({
  // page: z.number().catch(1),
  // tab: z.string().catch(""),
  // sort: z.enum(['newest', 'oldest', 'price']).catch('newest'),
});

export const Route = createFileRoute('/_authLayout/documents/overview/$docId')({
  beforeLoad: async () => {
    if (!canAccess('document')) {
      throw notFound();
    }
  },
  component: DocumentItemComponent,
  validateSearch: documentSearchSchema,
});

function DocumentItemComponent() {
  // const fund = useHierarchyEndpoint();
  // const [menu, setMenu] = React.useState<ReactNode | null>(null)
  const match = useMatchRoute();
  const fundIdMatch = match({ to: '/documents/fund/$fundId' });
  const [_documents, setDocuments] = useState<Document[]>([]);
  // const params = useSearch({ from: "/documents/fund/$fundId" });
  const fundId = fundIdMatch ? fundIdMatch.fundId : false;

  useEffect(() => {
    if (fundId) {
      endpointDocumentsGET(`/${fundId}`).then((res) => {
        if (res) {
          setDocuments(res.documents);
        }
      });
    }
  }, [fundId]);

  if (fundIdMatch) {
    return <>Document overview</>;
  } else {
    <></>;
  }
}
